import { entrega_material_escolar_por_aluno } from "./entrega-material-escolar-por-aluno";
import { relatorio_de_entrega_de_material_escolar } from "./relatorio-de-entrega-material-escolar";
import { cadastro_material_escolar } from "./cadastro-material-escolar";
import { declaracao_de_frequencia } from "./declaracao-de-frequencia";
import { declaracao_de_transferencia } from "./declaracao-de-transferencia";
import { declaracao_de_conclusao } from "./declaracao-de-conclusao";
import { resumo_entrega_material_escolar } from "./resumo-entrega-material-escolar";
import { entrega_material_escolar_por_turma } from "./entrega-material-escolar-por-turma";
import { atestado_de_eliminacao } from "./atestado-de-eliminacao";

const material_escolar = [
  ...entrega_material_escolar_por_aluno,
  ...relatorio_de_entrega_de_material_escolar,
  ...declaracao_de_frequencia,
  ...declaracao_de_transferencia,
  ...cadastro_material_escolar,
  ...declaracao_de_conclusao,
  ...resumo_entrega_material_escolar,
  ...entrega_material_escolar_por_turma,
  ...atestado_de_eliminacao,
];

export { material_escolar };
